import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface ReportFilter {
  date_start?: string;
  date_end?: string;
  vendor_start?: string;
  vendor_end?: string;
  product_start?: string;
  product_end?: string;
  process_start?: string;
  process_end?: string;
  dept_start?: string;
  dept_end?: string;
}

export interface DetailItem {
  vendor_code: string;
  process_code: string;
  color_code1: string;
  color_code2: string;
  unit: string;
  qty: number;
  amount: number;
  unit_price: number;
}

export interface SubtotalItem {
  vendor_code: string;
  unit: string;
  total_qty: number;
  total_amt: number;
  unit_price: number;
}

export interface VendorSummary {
  vendor_code: string;
  memo: string;
}

export interface UnitGrandTotal {
  unit: string;
  total_qty: number;
  total_amt: number;
}

export interface ReportData {
  details: DetailItem[];
  subtotals: SubtotalItem[];
  vendor_summary: VendorSummary[];
  grand_totals: UnitGrandTotal[];
  grand_memo: string;
}

export interface ReportResponse {
  data?: ReportData;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const d319Api = {
  async query(filter: ReportFilter): Promise<ReportResponse> {
    // Remove empty string params
    const body: Record<string, string> = {};
    for (const [k, v] of Object.entries(filter)) {
      if (v && v.trim() !== '') {
        body[k] = v.trim();
      }
    }
    const res = await apiClient.post('/api/d319/report', body);
    return res.data;
  },
};
